import React from 'react';
import './App.css';
import './styles/dark-theme.css';
import './styles/admin-tables.css';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Login from './Pages/Login/Login';
import LoadingAnimation from './Component/LoadingAnimation/LoadingAnimation';
import { useSelector } from 'react-redux';
import Sidebar from './Sidebar/Sidebar';
import { useTheme } from './Context/ThemeContext';
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/css/bootstrap.min.css";

function App() {
  const { loading } = useSelector((state) => state.admin);
  const { resolvedTheme } = useTheme();
 
  if (process.env.NODE_ENV === 'production') {
    console.log = () => { };
    console.error = () => { };
    console.warn = () => { };
    console.info = () => { };
    console.debug = () => { };
  }  

  return (
    <>
   {loading &&  <LoadingAnimation/>}
   <ToastContainer theme={resolvedTheme} />
      <React.Fragment>
        <BrowserRouter>
          <Routes>
            <Route path="/"   element={<Login/>}></Route>
          <Route path="/dashboard/*" end   element={<Sidebar />}></Route>
          </Routes>
        </BrowserRouter>
      </React.Fragment>
    </>
  );
}

export default App;